import { MediaItem } from '../../backend/backendapi';
import { Marker } from './types';
import type MarkerCanvas from './MarkerCanvas';
import CellStore from '../../../stores/CellStore';
import ActivityStore from '../../../stores/ActivityStore';

export default class State {
  activityStore = new ActivityStore();
  cellStore = new CellStore();
  media: MediaItem | null = null;
  markers: Marker[] = [];
  selectedMarkerId: string | null = null;

  canvasRef: MarkerCanvas | null = null;

  // filtering
  filterText: string = '';
  onlyIssues: boolean = false;
}